"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetMenuOrdersDpayDataResponseToJSON = exports.GetMenuOrdersDpayDataResponseFromJSONTyped = exports.GetMenuOrdersDpayDataResponseFromJSON = void 0;
var _1 = require("./");
function GetMenuOrdersDpayDataResponseFromJSON(json) {
    return GetMenuOrdersDpayDataResponseFromJSONTyped(json, false);
}
exports.GetMenuOrdersDpayDataResponseFromJSON = GetMenuOrdersDpayDataResponseFromJSON;
function GetMenuOrdersDpayDataResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'menuOrders': (json['menuOrders'].map(_1.DpayMenuOrdersFromJSON)),
    };
}
exports.GetMenuOrdersDpayDataResponseFromJSONTyped = GetMenuOrdersDpayDataResponseFromJSONTyped;
function GetMenuOrdersDpayDataResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'menuOrders': (value.menuOrders.map(_1.DpayMenuOrdersToJSON)),
    };
}
exports.GetMenuOrdersDpayDataResponseToJSON = GetMenuOrdersDpayDataResponseToJSON;
